import Vue from "vue"
import Vuetify from "vuetify/lib"

import "@mdi/font/css/materialdesignicons.css"

import colors from "vuetify/lib/util/colors"

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: colors.grey.darken1,
        secondary: "#ffd300" /* Brokk yellow */,
        accent: "#1A1A1A" /* Brokk near-black */,
        success: "#3c8a2e",
        info: "#888888" /* Brokk mid-gray */,
        alert: "#d2492a",
        warning: "#ffd300" /* Brokk yellow */,
        //error: colors.red,
        details_background: colors.grey.lighten4,
        muted: colors.grey,
        generic: colors.grey.lighten3
      }
    }
  }
})
